import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Neurolure · Your Gateway to Enhanced Living</p>
        <h1>Unlock Your Mind's Potential.</h1>
        <p className="lede">
          At Neurolure, we empower you to enhance your cognitive abilities and overall well-being. Discover innovative solutions designed to elevate your mental performance and enrich your daily life.
        </p>
        <div className="cta-row">
          <a href="https://neurolure.com/products" target="_blank">
            Explore Our Products
          </a>
          <a href="https://neurolure.com/about" target="_blank" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Experience Clarity</h2>
          <p>
            Our cutting-edge products are formulated to help you achieve mental clarity and focus, empowering you to tackle your day with confidence.
          </p>
        </article>
        <article>
          <h2>Enhance Your Performance</h2>
          <p>
            Whether at work or play, our solutions are designed to boost your cognitive performance, helping you reach your full potential.
          </p>
        </article>
        <article>
          <h2>Join a Community of Innovators</h2>
          <p>
            Connect with like-minded individuals who are committed to personal growth and mental enhancement. Together, we can achieve more.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;